import React from 'react';
import '../css/nav.css';
import Scrollme from './Scrollme';

const Nav = () => {
  
  return (
    <nav className="nav">
        <img src={require("../images/muselogo.svg")} alt="Muse Logo" onClick={() => Scrollme("#home")}></img>
        
    </nav>
  );
};

export default Nav;